import BuyerLoginPage from './BuyerLoginPage';

export default BuyerLoginPage;
